export const WixFeatureObj = [
    {
      title: "See Wix contact details in CausalFunnel",
      desc: "Solve your customer cases without having to leave CausalFunnel panel.",
    },
    {
      title: "Map contact properties",
      desc: "Manually add contact properties to be synced with Wix.",
    },
    {
      title: "Automatically create contacts",
      desc: "New contacts and subscribers from CausalFunnel will be added and updated in Wix.",
    },
  ];
  
  export const WixInstallGuide = [
    { id: 1, content: "Click the button below to add a new authorization" },
    { id: 2, content: "Log in to your Wix account in the popup" },
    { id: 3, content: "Click the 'Allow' button" },
  ];
  